import { SearchByItem } from "@app/shared/classes/general";
import { TableColumnDef } from "@app/shared/components/smart-data-grid/data-grid/data-grid.constants";
import { smartSearchType } from "@app/shared/components/smart-search-form/smart-search-form.constant";
import { DynamicTranslate } from "@app/shared/pipes/dynamic-translate";
import { BusinessHelper } from "@app/shared/utils/business-helper";

export enum KpiConfigurationFieldName {
  kpiCategoryName = "kpiCategoryName",
  categoryWeight = "categoryWeight",
  kpiName = "kpiName",
  weight = "weight",
  kpi_Translation_Id = "kpi_Translation_Id",
  kpiCategory_Translation_Id = "kpiCategory_Translation_Id",

  country = "country",
  businessType = "businessType"
}

enum FieldLabel {
  TOTAL_WEIGHT = "ml_144143",
  KPI_CATEGORY = "ml_144140",
  CATEGORY_WEIGHT = "ml_144141",
  KPI_NAME = "ml_143913",
  WEIGHT = "ml_144137",
  COUNTRY = "ml_143912",
  BUSINESS_TYPE = "ml_144070"
}

export const DataGridColumnDef: TableColumnDef[] = [
  {
    text: FieldLabel.KPI_NAME,
    name: KpiConfigurationFieldName.kpi_Translation_Id,
    pipe: DynamicTranslate
  },
  {
    text: FieldLabel.KPI_CATEGORY,
    name: KpiConfigurationFieldName.kpiCategory_Translation_Id,
    pipe: DynamicTranslate
  },
  {
    text: FieldLabel.WEIGHT,
    name: KpiConfigurationFieldName.weight
  },
]

const KpiConfigurationSearchByList: SearchByItem[] = [
  {
    searchBy: KpiConfigurationFieldName.businessType, searchByLabel: FieldLabel.BUSINESS_TYPE, searchByType: smartSearchType.singleSelect,
    searchDropDownValue: BusinessHelper.GetCombinedBusinessTypeDropDownList()
  },
];

export const GetKpiConfigurationSearchByList = () => {
  var result = KpiConfigurationSearchByList.slice();
  return result;
}
